import { AfterContentChecked, AfterContentInit, AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { PanoramaService } from 'src/app/services';
import { Guid } from 'guid-typescript';
import { IFloorplanSettings } from '../../shared/models/floorplan-settings.interface';

@Component({
  selector: 'app-floor-plan',
  templateUrl: './floor-plan.component.html',
  styleUrls: ['./floor-plan.component.less']
})
export class FloorPlanComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy, AfterContentChecked {

  @Input() onPluginManagerLoad: ReplaySubject<any> | undefined;
  @Input() interactive: boolean = true;
  @Input() floor: string | undefined;
  @Input() floorplanSettings: IFloorplanSettings | undefined;

  pluginManager: any;
  situSystems: any;
  pluginName: string;
  plugin: any;
  shouldInitAfterViewShow = false;

  constructor(private panoramaService: PanoramaService) {
    this.pluginName = "SituFloorPlan" + this.floor + Guid.create().toString().replace("-", "");
  }

  ngAfterViewInit(): void {
    this.onPluginManagerLoad?.subscribe(x => this.init(x));
  }

  ngAfterContentChecked() {
    if (this.shouldInitAfterViewShow && document.getElementById(this.pluginName)) {
      this.shouldInitAfterViewShow = false;
      this.init(this.pluginManager);
    }
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.pluginManager && this.plugin?.parentElement &&
      (changes.planScalingFactor || changes.roomNameFontSize)) {
      this.pluginManager.removePlugin(this.pluginName);

      if (document.getElementById(this.pluginName)) {
        this.init(this.pluginManager);
      }
      else {
        this.shouldInitAfterViewShow = true;
      }
    }
  }

  ngOnDestroy() {
    if (this.plugin) {
      this.pluginManager.removePlugin(this.pluginName);
      this.shouldInitAfterViewShow = false;
    }
  }

  init(pluginManager: any) {
    this.situSystems = this.panoramaService.situSystems;
    this.pluginManager = pluginManager;

    let floorplanSettings = new this.situSystems.FloorplanSettings({ ...new this.situSystems.FloorplanSettings(null), ...this.floorplanSettings });
    let div = this.pluginName;

    this.plugin = new this.situSystems.SVGFloorPlan(
      div,
      this.floor,
      this.interactive,
      floorplanSettings
    );
    this.pluginManager.addPlugin(this.plugin);
    this.pluginManager.addEventListener("homereset", (e: any) => {
      let plugin = this.pluginManager.plugins.find((x: any) => x.name == this.pluginName);
      if (plugin) {
        plugin.settings = new this.situSystems.FloorplanSettings({ ...new this.situSystems.FloorplanSettings(null), ...this.floorplanSettings });
      }
      this.plugin = plugin;
    });
  }
}
